<div class="maintenance-container">
  <!-- Dynamic downtime info -->
  <div *ngIf="activeDowntime && !isLoading" class="maintenance-content">
    <div class="maintenance-icon">⚙️</div>
    <h1>Supplier Gateway is Currently Offline</h1>
    <p class="maintenance-description">{{ activeDowntime.description }}</p>
    
    <div class="maintenance-schedule">
      <table>
        <tr>
          <th>Start Time</th>
          <td>{{ activeDowntime.startDateTime | date:'EEEE, MMMM d, yyyy h:mm a' }}</td>
        </tr>
        <tr>
          <th>Expected End Time</th>
          <td>{{ activeDowntime.endDateTime | date:'EEEE, MMMM d, yyyy h:mm a' }}</td>
        </tr>
      </table>
    </div>

    <p class="maintenance-note">
      This page will automatically refresh when the system comes back online.
    </p>
  </div>

  <!-- Fallback when API is unreachable -->
  <div *ngIf="!activeDowntime && !isLoading" class="maintenance-content">
    <div class="maintenance-icon">⚙️</div>
    <h1>Supplier Gateway is Currently Unavailable</h1>
    <p class="maintenance-description">
      We're performing scheduled maintenance. We'll be back online shortly.
    </p>
    <p class="maintenance-note">
      Please try again in a few minutes. This page will automatically refresh.
    </p>
  </div>

  <!-- Loading state -->
  <div *ngIf="isLoading" class="maintenance-content">
    <p>Checking system status...</p>
  </div>
</div>